import auth from './auth'
import user from './user'
import dom from './dom'
import toast from './toast'
import news from './news'
import profilePosts from './profilePosts'

export default {
  auth,
  user,
  dom,
  toast,
  news,
  profilePosts
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js